import { Component, OnInit, Directive } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { AppService } from "src/app/app.service";
import { Global } from "../../../global";
import { Subject } from "rxjs";
import { ModalPage } from "src/app/modals/modal/modal.page";
import { ModalComponent } from "src/app/modals/modal/modal.component";
import { AppHeaderService } from "../../header/app-header/app-header.service";

export interface LessonSettings {
  passrate: number;
  sapcode: string;
  maxattempts: number;
  validitymonths: number;
  trainingarea: string;
  trainingarea_guid: string;
  active: boolean;
  induction: boolean;
  randomised: boolean;
  allowlearning: boolean;
  issurvey: boolean;
  skipquestionreview: boolean;
  skipaudiofeedback: boolean;
  showlessoncontent: boolean;
  Lessoncontent_guid: string;
}

@Component({
  selector: "app-datepicker-modal",
  templateUrl: "./question-modal.page.html",
  styleUrls: ["./question-modal.page.scss"],
})
export class QuestionModalPage implements OnInit {
  callingFilter: string;
  User_GUID: string;
  Vendor_GUID: string;
  questionList: any;
  questionSelectedList: any;
  loadingDone: boolean = false;
  Question: any;
  hoveringObject: any = null;
  diceImage: any;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private formBuilder: FormBuilder,
    private appservice: AppService,
    public globals: Global,
    public modalController: ModalController,
    private appHeaderService: AppHeaderService
  ) { }

  ngOnInit() {
    this.callingFilter = this.navParams.data.paramObject.callingFilter;
    this.User_GUID = this.navParams.data.paramObject.User_GUID;
    this.Vendor_GUID = this.navParams.data.paramObject.Vendor_GUID;
    this.Question = this.navParams.data.paramObject.Question;

    if (this.Question == null) {
      this.createEmptyQuestion();
    }
    this.changeDice();

    this.loadingDone = true;
  }

  onQuestionClick() {
    if (this.Question.text.indexOf("Question text") !== -1)
      this.Question.text = "";
    if (this.Question.data.text.indexOf("Question text") !== -1)
      this.Question.data.text = "";
  }

  createEmptyQuestion() {
    //Create temporary new Question structure
    var GUID = this.appservice.GUID();
    var Translation_GUID = this.appservice.GUID();
    var Question_GUID = this.appservice.GUID();

    var Question = {
      id: GUID,
      icon: "glyphicon glyphicon-check",
      text: "Question text",
      MediaType: "Assessment",
      ContentType_GUID: "B295E6C1-A09C-4781-B4B4-D389DBC6F01A",
      data: null,
    };

    var data = {
      id: GUID,
      GUID: GUID,
      text: "Question text",
      Editable: true,
      NoOptionsForSurvey: -1,
      Type: "Content",
      ContentType_GUID: "B295E6C1-A09C-4781-B4B4-D389DBC6F01A",
      MediaType: "Assessment",
      //data.Question_GUID = GUID; //disabled this - we dont want same GUID for question as Scene_GUID
      Question_GUID: Question_GUID,
      QuestionContent_GUID: null,
      QuestionContent_GUID_Location: null,
      CreatedByUserID: this.globals.XRSUser.GUID,
      Translation_GUID: Translation_GUID,
      answers: [],
    };

    var GUID = this.appservice.GUID();
    var answer = {
      GUID: GUID,
      text: "Answer text",
      isCorrect: true,
    };

    data.answers.push(answer);

    Question.data = data;
    this.Question = Question;
  }

  async addPicture() {
    var paramObjectUpload = {
      modalType: "Upload",
      modalBodyText: "",
      modalHeaderText: "Uploading Picture",
      Content_GUID: null,
      allowedMedia: "All",
    };

    const modal = await this.modalController.create({
      component: ModalPage,
      componentProps: {
        paramObject: paramObjectUpload,
      },
      cssClass: "modals",
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
        let res = dataReturned.data;
        var found = false;

        this.Question.data.QuestionContent_GUID = dataReturned.data.GUID;
        //this.Question.data.QuestionContent_GUID_Location
      }
    });
    return await modal.present();
  }

  selectAnswer(answer) {
    if (answer.text.indexOf("Answer text") !== -1) answer.text = "";
  }

  changeDice() {
    if (this.Question.data.answers !== undefined) {
      var correctAnswers = this.Question.data.answers.filter(
        (x) => x.isCorrect == true
      ).length;

      if (correctAnswers < 1)
        this.diceImage = "assets/img/dices/" + correctAnswers + ".png";
    }
  }

  isHovering(answer: any) {
    if (answer == this.hoveringObject) return true;
    else return false;
  }

  isSelected(answer: any) {
    let selected = false;
    for (let ans of this.Question.data.answers) {
      if (ans === answer) {
        if (answer.selected === true) {
          return true;
        }
      }
    }
    return false;
  }

  mouseOver(answer: any) {
    this.hoveringObject = answer;
  }

  mouseOut(answer: any) {
    this.hoveringObject = null;
  }

  async onQuestionSelect(event: any, question: any) {
    await this.modalCtrl.dismiss(question);
  }

  addNewAnswer() {
    var GUID = this.appservice.GUID();
    var answer = {
      GUID: GUID,
      text: "",
      isCorrect: true,
    };

    this.Question.data.answers.push(answer);
    this.changeDice();
    if (this.Question.data.answers.length == 9) {
      alert("A maximum of 9 answers can be added per question");
    }
    return answer;
  }

  removeAnswer(answer) {
    const index = this.Question.data.answers.findIndex(
      (d) => d.GUID === answer.GUID
    );
    this.Question.data.answers.splice(index, 1);
    this.changeDice();
  }

  async closeModal() {
    await this.modalCtrl.dismiss(this.Question);
  }

  async onClose() {
    await this.modalCtrl.dismiss(this.Question);
  }

  // public onPagesLoaded(pagecount: PagesLoadedEvent): void {
  //   //this.TotalPages = pagecount.pagesCount;
  // }

  // public onPageRendered(pageRendered: PageRenderedEvent): void {
  //   //this.CurrentPage = pageRendered.pageNumber;
  // }
}
